import {
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  MESSAGE_TO_GUEST_PREVIEW,
  MESSAGE_TO_GUEST_NEW,
  MESSAGE_TO_GUEST_UPDATE,
  MESSAGE_TO_GUEST_REMOVE,
  MESSAGE_TO_GUEST_PROCESS_SUCCESS,
  MESSAGE_TO_GUEST_DATASOURCE_SUCCESS,
  MESSAGE_TO_GUEST_PROCESS_RESET,
  MESSAGE_TO_GUEST_RESET_STATE
  
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case MESSAGE_TO_GUEST_RESET_STATE:{
      return{
        loader: false,
        dataSerialize:{},
        dataSource:[],
        process:{},
        keyword:''
      }
    }
    case MESSAGE_TO_GUEST_PROCESS_RESET:{
      return {
        ...state,
        process:{status:false,action:"",message:""}
      }
    }
    case MESSAGE_TO_GUEST_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case MESSAGE_TO_GUEST_NEW: {
      return {
          ...state,
          loader: true
      }
    }
    case MESSAGE_TO_GUEST_UPDATE:{
        return{
          ...state,
          loader:true,
          dataSerialize:action.payload
        }
    }
    case MESSAGE_TO_GUEST_REMOVE: {
      return {
          ...state,
          loader: false
      }
    }
    case MESSAGE_TO_GUEST_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:{...action.payload}
      }
    }
    case MESSAGE_TO_GUEST_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    default:
      return state
  }
}